import { createContext } from 'react';
import { HeaderInfo } from './types';

export const initialValue: HeaderInfo = {
	general: {
		accountId: '',
		accountName: '',
		portalDomain: '',
		isLoggedIn: false,
		userId: '',
		userName: '',
		userPictureUrl: '',
		isPublic: false,
	},

	languages: {
		selected: 'en_US',
		available: [],
	},

	accounts: [],

	logo: {
		linkUrl: '/',
		imageUrl: '',
	},

	navItems: [],

	primaryCTA: {
		id: 'uploadMedia',
		url: '',
	},
	lastChange: new Date(),
	setLastChange: () => new Date(),

	homepage: {
		isEnabled: null,
		isConfigured: null,
		isAppAccessEnabled: null,
		isSplitEnabled: null,
	},
};

export const InfoContext = createContext<HeaderInfo>(initialValue);
